/**
 * @generated SignedSource<<84fc4808be0c65220502adec3a14f513>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToolsHotelImportsPageQuery$variables = {
  after?: string | null;
  first: number;
};
export type ToolsHotelImportsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HotelImportsTable_data">;
};
export type ToolsHotelImportsPageQuery = {
  response: ToolsHotelImportsPageQuery$data;
  variables: ToolsHotelImportsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ToolsHotelImportsPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HotelImportsTable_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ToolsHotelImportsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "HotelImportConnection",
        "kind": "LinkedField",
        "name": "hotelImports",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HotelImportEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HotelImport",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRows",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentRow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hotelsImported",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff575d0c44d68a61b74e7d8cbbd4bc05",
    "id": null,
    "metadata": {},
    "name": "ToolsHotelImportsPageQuery",
    "operationKind": "query",
    "text": "query ToolsHotelImportsPageQuery(\n  $first: Int!\n  $after: String\n) {\n  ...HotelImportsTable_data\n}\n\nfragment HotelImportStatus_hotelImport on HotelImport {\n  status\n}\n\nfragment HotelImportsTableRow_import on HotelImport {\n  id\n  totalRows\n  currentRow\n  hotelsImported\n  createdAt\n  updatedAt\n  ...HotelImportStatus_hotelImport\n}\n\nfragment HotelImportsTable_data on Query {\n  hotelImports(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ...HotelImportsTableRow_import\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "0c5030907cb3f86b5801bc9a7aac12e2";

export default node;
